import { render, staticRenderFns } from "./Gallery6.vue?vue&type=template&id=dab023fe&scoped=true&"
import script from "./Gallery6.vue?vue&type=script&lang=js&"
export * from "./Gallery6.vue?vue&type=script&lang=js&"
import style0 from "./Gallery6.vue?vue&type=style&index=0&id=dab023fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab023fe",
  null
  
)

export default component.exports